import { EventBus } from "../../../eventbus";

export default {
  props: {
    parentId: String,
  },
  data() {
    return {
      checked: false,
      sortOptions: [
        {
          label: "Name",
          defaultActive: false,
          sortKey: "name",
        },
      ],
      viewOptions: [
        {
          label: "list",
          defaultActive: true,
          icon: "listView",
        },
        {
          label: "tile",
          defaultActive: false,
          icon: "tileView",
        },
        {
          label: "masonry",
          defaultActive: false,
          icon: "masonry",
        },
      ],
    };
  },
  created() {
    EventBus.$on(`${this.parentId}-select-all`, (data) => {
      this.checked = data.checked;
    });
  },
  methods: {
    selectAllFiles(e) {
      EventBus.$emit(`${this.parentId}-select-all`, {
        checked: e.currentTarget.checked,
      });
    },
  },
};
